import { Avatar, Flex, FormControl } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Upload, Button as AntdButton, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { api } from "../../services/Api";
import { clearMask,  formatDateToBR, showToast } from "../../utils";
import { Input } from "../../components/Forms/Input";
import { Select } from "../../components/Forms/Select";
import { Section } from "./_Section";
import { useSeller } from "../../hooks/useSeller";
import { format } from "date-fns";
import { FormModal } from "../../components/Forms/FormModal";

const editGeneralInformationSchema = yup.object().shape({
  document: yup.string().required("Preenchimento obrigatório!"),
  companyName: yup.string().required("Preenchimento obrigatório!"),
  fantasyName: yup.string(),
  categoryId : yup.string(),
  ownerName: yup.string(),
  ownerDocument: yup.string(),
  birthdate: yup.string(),
  openingDate: yup.string().required("Preenchimento obrigatório!"),
  picture: yup.mixed(),
  sellerUrl: yup.string().url("Entre com uma url válida.").nullable(),
  tier: yup.string().nullable(),
  defaultTier: yup.string().nullable(),
});

interface GeneralInfoSectionProps {
  editSection: string;
  setEdit: (name: string) => void;
  id: string | undefined;
  seller: {
    icon: string;
    cnpj: string;
    document: string;
    fantasyName: string;
    companyName: string;
    ownerName: string;
    ownerDocument: string;
    birthdate: string;
    openingDate: string;
    categoryId?:string;
    allowedForInternationalDocument?: boolean;
    sellerUrl?: string;
    tier?: string;
    defaultTier?: string;
    mainActivity?: string;
  }
}

export interface GeneralInfoSectionData {
  document: string;
  companyName: string;
  fantasyName: string;
  ownerName: string;
  ownerDocument: string;
  birthdate: string;
  openingDate: string;
  categoryId:number;
  allowedForInternationalDocument: boolean;
  sellerUrl?: string;
  mainActivity?: string;
}

interface Category {
  id: number;
  name: string;
  uuid:string;
}

interface Tiers {
  tier: string;
  label: string;
}



export function GeneralInfoSection({ editSection, setEdit, id, seller}: GeneralInfoSectionProps) {
  const [filePreview, setFilePreview] = useState("");
  const [listCategory, setListCategory] = useState<Category[] | undefined>();
  const [listTiers, setListTiers] = useState<Tiers[] | undefined>();
  const { patchBasic, patchIcon, getCategory, getTiers, patchTiers } = useSeller();
  const [tierEditionModalState, setTierEditionModalState] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const birthFormattedDate = (seller.birthdate && 
    seller.birthdate !== "null") ? formatDateToBR(seller?.birthdate) : "";



    //eslint-disable-next-line
  const openingFormattedDate = (seller.openingDate && seller.openingDate !== "null") ? format(new Date(`${seller?.openingDate}T00:00:00`), 'dd/MM/yyyy') : "";
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(editGeneralInformationSchema),
  });

  function setDefaultData() {
    setValue("document", seller?.document);
    setValue("birthdate", formatDateToBR(seller?.birthdate));
    setValue("categoryId", seller?.categoryId ?? "");
    setValue("companyName", seller.companyName);
    setValue("fantasyName", seller?.fantasyName);
    setValue("icon", seller?.icon);
    setValue("openingDate", seller?.openingDate);
    setValue("ownerDocument", seller?.ownerDocument);
    setValue("ownerName", seller?.ownerName);
    setValue("allowedForInternationalDocument", seller?.allowedForInternationalDocument ? "1" : "0")
    setValue("sellerUrl", seller?.sellerUrl)
    setValue("tier", seller?.tier)
    setValue("defaultTier", seller?.tier)
    setValue("mainActivity", seller?.mainActivity)
  }
  //submit geral
  const onSubmit = handleSubmit(async ({document, companyName, fantasyName, ownerName, ownerDocument, birthdate, openingDate, categoryId, allowedForInternationalDocument, sellerUrl, mainActivity}: GeneralInfoSectionData) => {
    const generalInformationData = {
      document : clearMask(document),
      companyName,
      fantasyName,
      ownerName,
      ownerDocument: ownerDocument !== "" ? clearMask(ownerDocument) : null,
      birthdate: birthdate === "" ? "1900-01-01" : birthdate.split("/").reverse().join("-"), 
      openingDate: openingDate ? openingDate.split("/").reverse().join("-") : '2023-12-23',
      categoryId,
      allowedForInternationalDocument: Boolean(allowedForInternationalDocument),
      sellerUrl,
      mainActivity,
    }
    try {
      await patchBasic(generalInformationData, id);
      setEdit("");
      showToast({ message: "Informações editadas com sucesso", type: "success" });
      return
    } catch (error: any) {
      setEdit("");
      error?.response?.data?.errors?.map((error:any) => (
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`
        })
      ));
    }

  });

  const onPatchTiers = async (tier: string) => {
    try {
      setIsSubmitting(true);
      await patchTiers(tier, id);
      setValue("defaultTier", tier);
      showToast({ message: "Tier atualizado com sucesso", type: "success" });
    } catch (error: any) {
      showToast({ message: "Erro ao atualizar tier", type: "error" });
    } finally {
      setIsSubmitting(false);
      setEdit("");
      setTierEditionModalState(false);
    }
  }

  const props = {
    name: 'file',
    headers: {
        //@ts-ignore
        authorization: api.defaults.headers["Authorization"],
    },
    customRequest: ({ onSuccess, onError, file }: any) => {
      patchIcon(id).then(res => {
            const requestOptions = {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'image/*' ,
                    'Access-Control-Allow-Origin': process.env.REACT_APP_FRONT_URL,
                },
                body: file
            };
            //@ts-ignore
            fetch(res.data.urlUpload, requestOptions);
            onSuccess(file);
        })
    },
    onRemove: () => {
        setFilePreview("");
    },
    async onChange(info: any) {
        if (info.file.status !== 'uploading') {
        }
        if (info.file.status === 'done') {
            message.success(`o upload ${info.file.name} foi feito com sucesso.`);
        } else if (info.file.status === 'error') {
            message.error(`o upload ${info.file.name} falhou.`);
        }
        let src = info.file.url;
        if (!src) {
          src = await new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(info.file.originFileObj);
            reader.onload = () => resolve(reader.result);
          });
        }
        const image = new Image();
        image.src = src;
        setFilePreview(image.src)
    },
  };


  const listCategoryData = async () =>{
    try {
      const response : any = await getCategory();
      if(response !== undefined){
        setListCategory(response.data)
      }

      return response
    } catch (error: any) {
      return error
    }
  }

  const listTiersData = async () => {
    try {
      const response : any = await getTiers();
      if(response !== undefined){
        setListTiers(response.data)
      }
    } catch (error: any) {
      return error
    }
  }

  useEffect(()=>{
    setDefaultData();
    listCategoryData();
    listTiersData();
    //eslint-disable-next-line
  },[])

  return (
    <>
      <FormModal
        title="Editar tier do vendedor"
        isOpen={tierEditionModalState}
        onClose={() => setTierEditionModalState(!tierEditionModalState)}
        handleConfirmModal={() => onPatchTiers(watch("tier"))}
        isSubmitting={isSubmitting}
        width="420px"
        confirmationButtonText="Salvar"
        isAllowToSubmit
      >
        <Flex
          gap="4"
          direction="column"
        >
            <Select
                name="tier"
                label=""
                value={watch("tier")}
                onChange={(e)=> setValue("tier", e.target.value)}
                _disabled={{
                  bg: "transparent",
                  border: "none",
                }}
                placeholder="Selecione um tier"
              >
              {listTiers?.map((item) => (
                <option key={item?.tier} value={item?.tier}>{item?.label}</option>
              ))}
            </Select>
        </Flex>
      </FormModal>
      <Section
          sectionTitle="Informações gerais"
          isEdit={editSection === "generalInformation"}
          onClickEditButton={() => {
            setEdit("generalInformation");
          }}
          onClickConfirmButton={onSubmit}
      >
        <Flex gap={4} >
          <FormControl maxWidth="280px">
            <Input
              label="Documento"
              mask="cnpj"
              maxLength={18}
              defaultValue={seller.cnpj}
              name="document"
              p="0"
              register={{ ...register("document") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              isDisabled={editSection !== "generalInformation"}
              errors={errors?.document}
            />
          </FormControl>
          <FormControl maxWidth="280px">
            <Input
              label="Razão social"
              defaultValue={seller.companyName}
              name="companyName"
              p="0"
              register={{ ...register("companyName") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              isDisabled={editSection !== "generalInformation"}
              errors={errors?.companyName}
            />
          </FormControl>
          <FormControl maxWidth="280px">
            <Input
              label="Nome fantasia"
              defaultValue={seller.fantasyName}
              name="fantasyName"
              p="0"
              register={{ ...register("fantasyName") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              isDisabled={editSection !== "generalInformation"}
              errors={errors?.fantasyName}
            />
          </FormControl>
          <FormControl maxWidth="180px" ml="8">
            
            <Flex align="center" gap={2}>
              <Avatar
                //@ts-ignore
                src={filePreview ? filePreview : seller?.icon}
                w="50px"
                h="50px"
                borderRadius="4px"
                objectFit="cover"
              />
              <Upload {...props} maxCount={1}>
                <AntdButton
                  icon={<UploadOutlined />}
                  disabled={editSection !== "generalInformation"}
                >
                  Upload
                </AntdButton>
              </Upload>
            </Flex>
          </FormControl>
        </Flex>
        <Flex gap={4}>
          <FormControl maxWidth="280px">
            
            <Input
              label="Nome responsável"
              defaultValue={seller.ownerName}
              name="ownerName"
              p="0"
              register={{ ...register("ownerName") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              isDisabled={editSection !== "generalInformation"}
            />
          </FormControl>
          <FormControl maxWidth="280px">
            <Input
              label="CPF responsável"
              defaultValue={seller.ownerDocument}
              name="ownerDocument"
              p="0"
              register={{ ...register("ownerDocument") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              mask="cpf"
              placeholder="0XX.0XX.0XX-0X"
              isDisabled={editSection !== "generalInformation"}
            />
          </FormControl>
          <FormControl maxWidth="280px">
            <Input
              label="Data de nascimento"
              defaultValue={birthFormattedDate}
              name="birthdate"
              p="0"
              register={{ ...register("birthdate") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              placeholder="00/00/0000"
              isDisabled={editSection !== "generalInformation"}
              mask="date"
              maxLength={10}
            />
          </FormControl>
          <FormControl maxWidth="280px">
            <Input
              label="Data de abertura"
              defaultValue={openingFormattedDate}
              name="openingDate"
              p="0"
              register={{ ...register("openingDate") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              placeholder="00/00/0000"
              isDisabled={editSection !== "generalInformation"}
              mask="date"
              maxLength={10}
            />
          </FormControl>
            
        </Flex>
        <Flex gap={4} align="center">
          <FormControl maxWidth="280px">
            <Input
              label="Site"
              defaultValue={seller?.sellerUrl}
              name="sellerUrl"
              p="0"
              register={{ ...register("sellerUrl") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              isDisabled={editSection !== "generalInformation"}
              errors={errors.sellerUrl}
            />
          </FormControl>
          <FormControl maxWidth="280px">
              <Select
                name="categoryId" 
                label="Categoria" 
                value={watch("categoryId")}
                onChange={(e)=> setValue("categoryId", e.target.value)}
                _disabled={{
                  bg: "transparent",
                  border: "none",
                }}
                isDisabled={editSection !== "generalInformation"}
              > 
                <option value="">Escolha uma categoria</option>
            
                {listCategory?.map((item) => (
                  <option key={item?.id} value={item?.id}>{item?.name}</option>
                ))}
              </Select>
          </FormControl>
          <FormControl maxWidth="280px">
              <Select
                name="allowedForInternationalDocument" 
                label="Permitir documentos internacionais" 
                value={watch("allowedForInternationalDocument")}
                onChange={(e)=> setValue("allowedForInternationalDocument", e.target.value)}
                _disabled={{
                  bg: "transparent",
                  border: "none",
                }}
                isDisabled={editSection !== "generalInformation"}
              > 
                <option value="0">Nao</option>
                <option value="1">Sim</option>
              </Select>
          </FormControl>
          <FormControl maxWidth="280px">
            <Input
              label="CNAE principal"
              defaultValue={seller?.mainActivity}
              name="mainActivity"
              p="0"
              register={{ ...register("mainActivity") }}
              _disabled={{
                bg: "transparent",
                border: "none",
              }}
              isDisabled={editSection !== "generalInformation"}
            />
          </FormControl>
        </Flex>
      </Section>
      <Section
        sectionTitle="Tiers"
        isEdit={editSection === "tiers"}
        onClickEditButton={() => {
          setTierEditionModalState(true);
        }}
        onClickConfirmButton={() => {}}
      >
        <Flex gap={4}>
            <FormControl maxWidth="280px">
            <Select
                name="defaultTier"
                label=""
                value={watch("defaultTier")}
                onChange={(e)=> setValue("defaultTier", e.target.value)}
                _disabled={{
                  bg: "transparent",
                  border: "none",
                }}
                placeholder="Selecione um tier"
                sx={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                }}
                isDisabled
              >
              {listTiers?.map((item) => (
                <option key={item?.tier} value={item?.tier}>{item?.label}</option>
              ))}
            </Select>
          </FormControl>
        </Flex>
      </Section>
    </>

  );
}